
export const API_URL = import.meta.env.VITE_API_URL

export const ARTICULOS = `${API_URL}api/articulos`;

export const CLIENTES = `${API_URL}api/clientes`;

export const DOCUMENTOS = `${API_URL}api/documentos`;